// Blushi-Skin Theme - Wishlist JavaScript (Shopify Native with localStorage)
(function() {
  'use strict';
  
  var STORAGE_KEY = 'blushi-wishlist';

  // Get wishlist from localStorage
  function getWishlist() {
    try {
      var data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      return [];
    }
  }

  // Save wishlist to localStorage
  function saveWishlist(wishlist) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
      updateWishlistCount();
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { wishlist: wishlist } }));
    } catch (e) {
      console.error('Error saving wishlist:', e);
    }
  }

  // Check if product is in wishlist
  function isInWishlist(productId) {
    var wishlist = getWishlist();
    return wishlist.includes(String(productId));
  }

  // Toggle product in wishlist
  function toggleWishlist(productId, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    var wishlist = getWishlist();
    var id = String(productId);
    var index = wishlist.indexOf(id);

    if (index > -1) {
      wishlist.splice(index, 1);
      showToast('Removed from wishlist');
    } else {
      wishlist.push(id);
      showToast('Added to wishlist');
    }

    saveWishlist(wishlist);
    updateWishlistButtons();
  }

  // Update all wishlist buttons on page
  function updateWishlistButtons() {
    document.querySelectorAll('.wishlist-btn').forEach(function(btn) {
      var productId = btn.dataset.productId;
      if (isInWishlist(productId)) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  // Update wishlist count in navigation
  function updateWishlistCount() {
    var wishlist = getWishlist();
    document.querySelectorAll('.nav-wishlist-count').forEach(function(el) {
      if (wishlist.length > 0) {
        el.textContent = wishlist.length;
        el.classList.remove('hidden');
      } else {
        el.classList.add('hidden');
      }
    });
  }

  // Show toast notification
  function showToast(message) {
    var existingToast = document.querySelector('.wishlist-toast');
    if (existingToast) existingToast.remove();

    var toast = document.createElement('div');
    toast.className = 'wishlist-toast';
    toast.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg><span>' + message + '</span>';

    if (!document.getElementById('wishlist-toast-styles')) {
      var styles = document.createElement('style');
      styles.id = 'wishlist-toast-styles';
      styles.textContent = '.wishlist-toast{position:fixed;top:100px;left:50%;transform:translateX(-50%);display:flex;align-items:center;gap:10px;background-color:hsl(var(--color-cream));border:1px solid hsl(var(--color-blush));border-radius:8px;padding:14px 20px;box-shadow:0 10px 40px -10px rgba(0,0,0,0.15);z-index:9999;animation:toastSlide 0.3s ease,toastFade 0.3s ease 2.7s forwards}.wishlist-toast svg{color:hsl(var(--color-blush))}.wishlist-toast span{font-family:var(--font-body);font-size:14px;color:hsl(var(--color-charcoal))}@keyframes toastSlide{from{opacity:0;transform:translateX(-50%) translateY(-20px)}to{opacity:1;transform:translateX(-50%) translateY(0)}}@keyframes toastFade{to{opacity:0}}';
      document.head.appendChild(styles);
    }

    document.body.appendChild(toast);
    setTimeout(function() { toast.remove(); }, 3000);
  }

  // Render wishlist page products
  function renderWishlistPage() {
    var loadingEl = document.getElementById('wishlist-loading');
    var emptyEl = document.getElementById('wishlist-empty');
    var gridEl = document.getElementById('wishlist-grid');
    var countEl = document.getElementById('wishlist-count');
    
    // Only run on wishlist page
    if (!loadingEl || !emptyEl || !gridEl) return;
    
    var wishlist = getWishlist();
    
    // Update count text
    if (countEl) {
      countEl.textContent = wishlist.length + ' saved item' + (wishlist.length !== 1 ? 's' : '');
    }
    
    // Show empty state if no items
    if (wishlist.length === 0) {
      loadingEl.classList.add('hidden');
      gridEl.classList.add('hidden');
      emptyEl.classList.remove('hidden');
      return;
    }
    
    // Fetch products from Storefront API or use product handles
    loadingEl.classList.remove('hidden');
    emptyEl.classList.add('hidden');
    gridEl.classList.add('hidden');
    
    // Fetch all products and filter by wishlist IDs
    fetch('/products.json?limit=250')
      .then(function(response) { return response.json(); })
      .then(function(data) {
        var products = data.products || [];
        var wishlistProducts = products.filter(function(product) {
          return wishlist.includes(String(product.id));
        });
        
        loadingEl.classList.add('hidden');
        
        if (wishlistProducts.length === 0) {
          emptyEl.classList.remove('hidden');
          gridEl.classList.add('hidden');
          return;
        }
        
        // Render product cards
        var html = '';
        wishlistProducts.forEach(function(product) {
          var image = product.images && product.images[0] ? product.images[0].src : '';
          var price = product.variants && product.variants[0] ? product.variants[0].price : '0.00';
          var variantId = product.variants && product.variants[0] ? product.variants[0].id : '';
          var available = product.variants && product.variants[0] ? product.variants[0].available : false;
          
          html += '<div class="wishlist-product-card" data-product-id="' + product.id + '">' +
            '<button class="wishlist-remove-btn" onclick="window.BlushiWishlist.toggleWishlist(' + product.id + ', event)" aria-label="Remove from wishlist">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
            '</button>' +
            '<a href="/products/' + product.handle + '" class="wishlist-product-link">' +
              '<div class="wishlist-product-image">' +
                (image ? '<img src="' + image.replace(/(\.[^.]+)$/, '_360x$1') + '" alt="' + product.title + '" loading="lazy">' : '<div class="wishlist-product-placeholder">🌿</div>') +
              '</div>' +
              '<div class="wishlist-product-info">' +
                '<h3 class="wishlist-product-title">' + product.title + '</h3>' +
                '<p class="wishlist-product-price">$' + parseFloat(price).toFixed(2) + '</p>' +
              '</div>' +
            '</a>' +
            '<button class="wishlist-add-to-cart" ' + (available ? 'data-add-to-cart data-variant-id="' + variantId + '"' : 'disabled') + '>' +
              (available ? 'Add to Ritual' : 'Sold Out') +
            '</button>' +
          '</div>';
        });
        
        gridEl.innerHTML = html;
        gridEl.classList.remove('hidden');
      })
      .catch(function(error) {
        console.error('Error loading wishlist products:', error);
        loadingEl.classList.add('hidden');
        emptyEl.classList.remove('hidden');
      });
  }

  // Initialize
  function init() {
    updateWishlistButtons();
    updateWishlistCount();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Listen for wishlist updates to re-render page
  document.addEventListener('wishlist:updated', function() {
    updateWishlistButtons();
    updateWishlistCount();
    renderWishlistPage();
  });

  // Expose functions globally
  window.toggleWishlist = toggleWishlist;
  window.BlushiWishlist = {
    getWishlist: getWishlist,
    isInWishlist: isInWishlist,
    toggleWishlist: toggleWishlist,
    updateWishlistButtons: updateWishlistButtons,
    updateWishlistCount: updateWishlistCount,
    renderWishlistPage: renderWishlistPage
  };
})();
